(ns common.schema.entities.liability
  (:require [clojure.string :as string]
            [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/text-simple-field :liability/description
                         "Description"
                         {:default-field-visibility :in-use-disabled
                          :constraints
                          {:constraint/mandatory-fn
                           (fn [field-value _entity-data]
                             (string/blank? (str field-value)))
                           :constraint/string-min-length 1}
                          :mandatory-config :mandatory/always
                          :system-required? true
                          :system-semantics
                          su/user-provided-system-required-field-semantics})
   (su/text-simple-field :liability/agreement-reference "Agreement reference"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use-disabled})
   (su/currency-field :liability/cur-max-amount "Max amount"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
   (su/date-field :liability/datetime-expiry-date "Expiry date"
                  {:authorization            su/access-user-user
                   :default-field-visibility :in-use-disabled})
   (su/option-field :liability/covered-by-insurance
                    "Covered by insurance"
                    {:default-field-visibility :in-use-disabled
                     :authorization            su/access-user-user})
   (su/currency-field :liability/cur-max-amount-covered "Max amount covered"
                      {:authorization            su/access-user-user
                       :default-field-visibility :in-use-disabled})
   (su/text-multiline-field :liability/notes "Notes"
                            {:authorization            su/access-user-user
                             :default-field-visibility :in-use-disabled})))
